import { Localization, enUS, hiIN } from '@mui/material/locale';

import { Locale } from '@klokhuis/core/Intl/types';

export const MuiLocalesMap: Record<Locale, Localization> = {
  [Locale.en]: enUS,
  [Locale.ta]: hiIN,
};
